module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /~/react/react.js
 ** module id = 345
 ** module chunks = 9
 **/